(function () {
  const carousel = document.querySelector('[data-bundle-carousel]');
  if (!carousel) return;

  const cards = carousel.querySelectorAll('.bundle-carousel__card');
  const summary = carousel.querySelector('[data-bundle-summary]');

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function updateSummary() {
    const selected = [...cards].filter(c => c.dataset.selected === 'true');
    const total = selected.reduce((sum, c) => sum + parseInt(c.dataset.price), 0);
    summary.textContent = selected.length
      ? `${selected.length} item${selected.length > 1 ? 's' : ''} selected · ${formatMoney(total)}`
      : '0 items selected';
  }

  function getSelectedItems() {
    return [...cards]
      .filter(c => c.dataset.selected === 'true')
      .map(c => ({ id: parseInt(c.dataset.variantId), quantity: 1 }));
  }

  async function addBundleItemsToCart() {
    const items = getSelectedItems();
    if (!items.length) return;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
  }

  function toggleCard(card) {
    const isSelected = card.dataset.selected === 'true';
    card.dataset.selected = isSelected ? 'false' : 'true';
    card.setAttribute('aria-pressed', String(!isSelected));
    updateSummary();
  }

  // Intercept add-to-cart-component click
  function bindATCInterceptor() {
    const atcComponent = document.querySelector('add-to-cart-component');
    if (!atcComponent || atcComponent.dataset.bundleBound) return;
    atcComponent.dataset.bundleBound = 'true';

    atcComponent.addEventListener('click', async function (e) {
      const items = getSelectedItems();
      if (!items.length) return; // no bundle items, proceed normally

      e.preventDefault();
      e.stopImmediatePropagation();

      const btn = atcComponent.querySelector('button');
      if (btn) {
        btn.setAttribute('disabled', true);
        btn.setAttribute('aria-busy', 'true');
      }

      await addBundleItemsToCart();

      if (btn) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
      }

      // Re-trigger click on the button to let the component handle it normally
      btn?.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));

    }, true); // capture phase
  }

  // Card interactions
  cards.forEach(card => {
    card.addEventListener('click', () => toggleCard(card));
    card.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleCard(card);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    bindATCInterceptor();
    setTimeout(bindATCInterceptor, 2000);
  });

  updateSummary();
})();
